import { ReactNode, useState } from 'react'

/** Borderless icon button used in the drawer header. */
const IconGhostButton = ({
  icon,
  title,
  onClick,
  disabled,
  active,
}: {
  icon: ReactNode
  title?: string
  onClick?: () => void
  disabled?: boolean
  /** The panel this button toggles is open. */
  active?: boolean
}) => {
  const [hover, setHover] = useState(false)
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      aria-pressed={active}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="flex cursor-pointer rounded-lg border-0 p-[6px] text-[17px]"
      style={{
        color: active ? '#008aa3' : '#5a6474',
        background: active
          ? '#e7f7fb'
          : hover && !disabled
          ? '#f1f3f8'
          : 'transparent',
        opacity: disabled ? 0.4 : 1,
      }}
    >
      {icon}
    </button>
  )
}

export default IconGhostButton
